import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createRef, useContext, useEffect } from 'react';
import clsx from 'clsx';
import { Checkbox } from '@skbkontur/react-ui';
import { EmployeeListContext } from '../EmployeeList.context';
import classes from '../EmployeeList.module.css';
const additionalColumnLabels = {
    birthday: 'День рождения',
    snils: 'СНИЛС',
    inn: 'ИНН ФЛ',
    email: 'Email',
};
export const ListHead = () => {
    const { state, handleSelectAll, isSingleSelection, additionalColumn } = useContext(EmployeeListContext);
    const checkbox = createRef();
    useEffect(() => {
        if (isSingleSelection) {
            return;
        }
        if (state.selectAll === 'indeterminate') {
            checkbox.current?.setIndeterminate();
        }
        else {
            checkbox.current?.resetIndeterminate();
        }
    }, [checkbox, state.selectAll, isSingleSelection]);
    return (_jsxs("div", { className: clsx([classes.listRow, classes.listHeader]), "data-tid": "employeesListHeader", children: [!isSingleSelection && (_jsx(Checkbox, { ref: checkbox, checked: state.selectAll === 'all', disabled: state.status === 'loading' || state.status === 'error' || state.selectAllStatus === 'loading', onValueChange: handleSelectAll, initialIndeterminate: state.selectAll === 'indeterminate', "data-tid": "employeeListSelectAllCheckbox" })), _jsx("div", { className: classes.listCellName, children: "\u0424\u0418\u041E" }), additionalColumn && (_jsx("div", { className: classes.listCellAdditional, children: additionalColumnLabels[additionalColumn] }))] }));
};
